/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface DockerRunArtifactCreatedData
 *
 */
// create custom validators for the regexes
export interface DockerRunArtifactCreatedData {
    /**
     *
     * #type string
     * #memberof DockerRunArtifactCreatedData
        
        
         */
    signedWriteUrl: string;
    /**
     *
     * #type string
     * #memberof DockerRunArtifactCreatedData
        
        
         */
    artifactId: string;
}
/**
 * Check if a given object implements the DockerRunArtifactCreatedData interface.
 */
export function instanceOfDockerRunArtifactCreatedData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "signedWriteUrl" in value;
    isInstance = isInstance && "artifactId" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const DockerRunArtifactCreatedDataTypiaAssertEquals = (input: any) => {
    return ((input: any): DockerRunArtifactCreatedData => {
        const __is = (input: any, _exceptionable: boolean = true): input is DockerRunArtifactCreatedData => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.signedWriteUrl && "string" === typeof input.artifactId && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["signedWriteUrl", "artifactId"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerRunArtifactCreatedData => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.signedWriteUrl || $guard(_exceptionable, {
                    path: _path + ".signedWriteUrl",
                    expected: "string",
                    value: input.signedWriteUrl
                })) && ("string" === typeof input.artifactId || $guard(_exceptionable, {
                    path: _path + ".artifactId",
                    expected: "string",
                    value: input.artifactId
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["signedWriteUrl", "artifactId"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunArtifactCreatedData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunArtifactCreatedData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const DockerRunArtifactCreatedDataTypiaAssertStringify = (input: DockerRunArtifactCreatedData): string => {
    return ((input: any): string => { const assert = (input: any): DockerRunArtifactCreatedData => {
        const __is = (input: any): input is DockerRunArtifactCreatedData => {
            return "object" === typeof input && null !== input && ("string" === typeof (input as any).signedWriteUrl && "string" === typeof (input as any).artifactId);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerRunArtifactCreatedData => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.signedWriteUrl || $guard(_exceptionable, {
                    path: _path + ".signedWriteUrl",
                    expected: "string",
                    value: input.signedWriteUrl
                })) && ("string" === typeof input.artifactId || $guard(_exceptionable, {
                    path: _path + ".artifactId",
                    expected: "string",
                    value: input.artifactId
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunArtifactCreatedData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunArtifactCreatedData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: DockerRunArtifactCreatedData): string => {
        const $string = (typia.createAssertStringify as any).string;
        return `{"signedWriteUrl":${$string((input as any).signedWriteUrl)},"artifactId":${$string((input as any).artifactId)}}`;
    }; return stringify(assert(input)); })(input);
};
export const DockerRunArtifactCreatedDataValidatorShape = {
    'signedWriteUrl': yup.string().defined(),
    'artifactId': yup.string().defined(),
};
export const DockerRunArtifactCreatedDataValidator = yup.object().shape(DockerRunArtifactCreatedDataValidatorShape);
export const DockerRunArtifactCreatedDataStringifyShapeProperties: ObjectSchema['properties'] = {
    'signedWriteUrl': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'artifactId': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
};
export const DockerRunArtifactCreatedDataStringifyShape: ObjectSchema = {
    title: 'DockerRunArtifactCreatedData Stringifier',
    type: 'object',
    properties: {
        ...DockerRunArtifactCreatedDataStringifyShapeProperties
    },
    required: [
        'signedWriteUrl',
        'artifactId',
    ],
};
export const DockerRunArtifactCreatedDataStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DockerRunArtifactCreatedDataStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const DockerRunArtifactCreatedDataStringify: (data: DockerRunArtifactCreatedData) => string = DockerRunArtifactCreatedDataStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function DockerRunArtifactCreatedDataFromJSON(json: any): DockerRunArtifactCreatedData {
    return DockerRunArtifactCreatedDataFromJSONTyped(json, false);
}
export function DockerRunArtifactCreatedDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DockerRunArtifactCreatedData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'signedWriteUrl': json['signedWriteUrl'],
        'artifactId': json['artifactId'],
    };
}
export function DockerRunArtifactCreatedDataToJSON(value?: DockerRunArtifactCreatedData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'signedWriteUrl': value.signedWriteUrl,
        'artifactId': value.artifactId,
    };
}
